/** biome-ignore-all lint/correctness/useHookAtTopLevel: useIsQuizEnabled does not change while mounted */
import { useQuestionsStore } from "@ext/markdown/elements/question/render/logic/QuestionsProvider";
import { useIsQuizEnabled } from "./useIsQuizEnabled";

export const useHasQuizNavigation = () => {
	if (!useIsQuizEnabled()) return false;
	return useQuestionsStore((store) => Object.keys(store.questions).length > 0);
};
